import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { type RootReducer } from "lib/redux/reducers";
import { useDispatch, useSelector } from "react-redux";
import { logoutRequest } from "lib/redux/auth/action";
import { PUBLIC_PATHS } from "routes/pagePath";
import { searchScript, searchResult } from "lib/redux/scripts/action";
import NavBarLayout from "./NavBarLayout";
import { Box, useBoolean } from "@chakra-ui/react";
import { convertParamsToString } from "helpers/stringManipulation";

const NavBar = ({ onOpenSideBar }: { onOpenSideBar?: () => void }) => {
  const history = useNavigate();
  const [searchText, setsearchText] = useState("");
  const [showSearch, setshowSearch] = useState(false);
  const user = useSelector<RootReducer, any>((state) => state.auth.user);
  const searchData = useSelector<RootReducer, any>((state) => state.scripts.search.data);
  const dispatch = useDispatch();

  const handleLogout = () => {
    dispatch(logoutRequest());
    history(PUBLIC_PATHS.LOGIN);
  };
  const [showDropdown, setshowDropdown] = useBoolean();

  const [currentCat, setcurrentCat] = useState("All");

  const onSearchChange = (e) => {
    const searchValue = e.target.value;
    if (!searchValue || searchValue === "") {
      setshowDropdown.off();
    } else {
      let query;
      if (currentCat === "Composer") {
        query = `composer=${searchValue}`;
      } else if (currentCat === "Custom Category") {
        query = `category=others&customCategory=${searchValue}`;
      } else if (currentCat === "All") {
        query = `name=${searchValue}`;
      } else {
        query = `name=${searchValue}&category=${currentCat}`;
      }
      dispatch(searchScript(`?${query}`));
    }
    setsearchText(searchValue);
    setshowDropdown.on();
  };
  const clickedSearchTerm = (term) => {
    setshowDropdown.off();
    setsearchText(term);
    let query;
    if (currentCat === "Composer") {
      query = `composer=${term}`;
    } else if (currentCat === "Custom Category") {
      query = `category=others&customCategory=${term}`;
    } else if (currentCat === "All") {
      query = `name=${term}`;
    } else {
      query = `name=${term}&category=${currentCat}`;
    }
    dispatch(searchResult(`?${query}`));
    const url = convertParamsToString(PUBLIC_PATHS.SEARCH_RESULT, { text: term });
    history(url);
  };
  const handleHide = () => {
    setshowDropdown.off();
  };
  return (
    <Box position="sticky" top="0" zIndex="15">
      <NavBarLayout
        handleLogout={handleLogout}
        onSearchChange={onSearchChange}
        clickedSearchTerm={clickedSearchTerm}
        handleHide={handleHide}
        user={user}
        searchData={searchData}
        searchText={searchText}
        showDropdown={showDropdown}
        currentCat={currentCat}
        setcurrentCat={setcurrentCat}
        showSearch={showSearch}
        setshowSearch={setshowSearch}
        onOpenSideBar={onOpenSideBar}
      />
    </Box>
  );
};
export default NavBar;
